import "./App.css";
import { useCallback, useEffect, useState } from "react";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FIREBASE_CONFIG } from "./config/app.config";
import SplashScreen from "./Generic/SplashScreen";
import DashboardRoutes from "./Routing/Routes";

function App() {
	const storedUserId = window.localStorage.getItem("userId"), 
		hasPreviouslyStoredLoginInfo = (storedUserId) ? true : false;
	const firebaseApp = initializeApp(FIREBASE_CONFIG);
	const auth = getAuth(firebaseApp);
	const [firebaseInitialized, setFirebaseInitialized] = useState(false);
	const [isLoggedIn, setLoginStatus] = useState(hasPreviouslyStoredLoginInfo);

    const handleAuthStateChange = useCallback((user) => {
        if (user) {
            setLoginStatus(true);
            if (storedUserId !== user.uid) {
                window.localStorage.setItem("userId", user.uid);
            }
        } else {
            setLoginStatus(false);
            window.localStorage.removeItem("userId");
        }
        setFirebaseInitialized(true);
    }, [storedUserId]);

	useEffect(() => {
		const unsubscribe =  auth.onAuthStateChanged(handleAuthStateChange);
		return () => unsubscribe();
	}, [auth, handleAuthStateChange]);

	return (
		<div className="App">
			<ToastContainer limit={3} isMobile breakpoint="600" />
			{(isLoggedIn && !firebaseInitialized) ? <SplashScreen /> : <DashboardRoutes isLoggedIn={isLoggedIn} /> }
		</div>
	);
}

export default App;
